var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2133 4.28694C11.9733 4.52694 11.9533 4.90028 12.1667 5.16694C13.1333 6.38028 13.64 8.04028 13.1867 9.78028C12.66 11.8136 11.0667 13.3336 9.04667 13.7403C5.64667 14.4136 2.66667 11.7869 2.66667 8.50028C2.66667 5.78028 4.7 3.54028 7.33334 3.21361V4.56028C5.24667 4.91361 3.71334 6.86695 4.04667 9.11361C4.30667 10.8536 5.75334 12.2536 7.5 12.4669C9.92667 12.7669 12 10.8736 12 8.50028C12 7.66695 11.7467 6.90028 11.3133 6.26028C11.0867 5.92695 10.6 5.90695 10.3133 6.18694L10.3067 6.19361C10.08 6.42028 10.06 6.77361 10.2333 7.04028C10.6333 7.65361 10.7933 8.44028 10.56 9.25361C10.3 10.1669 9.53334 10.8936 8.6 11.1003C6.86667 11.4803 5.33333 10.1736 5.33333 8.50028C5.33333 7.26028 6.18667 6.22695 7.33334 5.92695V7.35361C6.93334 7.58695 6.66667 8.00695 6.66667 8.50028C6.66667 9.23361 7.26667 9.83361 8 9.83361C8.73334 9.83361 9.33334 9.23361 9.33334 8.50028C9.33334 8.00695 9.06667 7.58028 8.66667 7.35361V2.30694C8.66667 2.04694 8.45334 1.83361 8.19334 1.83361C4.62 1.70028 1.54 4.54028 1.34667 8.10028C1.10667 12.4669 4.95334 15.9803 9.35334 15.0336C11.94 14.4803 13.94 12.5003 14.52 9.92028C14.9933 7.81361 14.3867 5.81361 13.2067 4.34028C12.96 4.02695 12.4933 4.00694 12.2133 4.28694Z",
    fill: "#1A2B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackChannel);
export default __webpack_public_path__ + "static/media/track-channel.b22c2808dbb9790a905ef948bf641118.svg";
export { ForwardRef as ReactComponent };